export default {
    namespaced: true,
    state: {
        factibilidad: null
    },
    mutations: {
        actualizarFactibilidad(state, factibilidad) {
            state.factibilidad = factibilidad;
        },
        resetearFactibilidad(state) {
            state.factibilidad = null
        }
    },
    actions: {
        async estadoFactibilidad({ commit }) {
            try {
                commit("resetearFactibilidad", null);
                const response = await axios.get("/api/factibilidad")

                commit("actualizarFactibilidad", response.data);
            } catch (error) {
                console.error(error);
                throw error;
            }
        }
    }
}

